//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports 
import { DepartmentModel, ProjectModel } from '@app/catalog';

@Component({
  selector: 'assign-department-to-project',
  standalone: false,
  templateUrl: './assign-department-to-project.component.html',
  styleUrl: './assign-department-to-project.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignDepartmentToProjectComponent {
  onCancelAssignment = output();

  projects = input.required<ProjectModel[]>();
  assignedDepartments = input.required<DepartmentModel[]>();
  departments = input.required<DepartmentModel[]>();



  public applyAssignment() {

  }
}
